import { QueryClient } from '@tanstack/vue-query';

const queryClient = new QueryClient();

export default queryClient;
